



export const RightSideBar= ({active,setActive})=>{
    return (
      <div className=" fixed z-10 right-0 top-0  hidden md:flex flex-col h-screen md:w-12 lg:w-20 font-serif  justify-center gap-3 ">
        <a
          href="https://www.instagram.com/youssef_ichiba/"
          className="text-sm md:text-base lg:text-lg hover:underline"
        >
          {" "}
          In
        </a>
        <a
          href="https://x.com/ichiba_youssef"
          className="text-sm md:text-base lg:text-lg hover:underline"
        >
          X
        </a>
        <a
          href="https://www.linkedin.com/in/youssef-ichiba-61921b137/"
          className="text-sm md:text-base lg:text-lg hover:underline"
        >
          Li
        </a>
        <a
          href="mailto:youssefichiba@gmail.com"
          className="text-sm md:text-base lg:text-lg hover:underline"
        >
          Mail
        </a>
      </div>
    );
}


